import React from 'react';
import { Card } from '@mui/material';

export default function SectionNote(props) {

    return (
        <>
            <Card style={{ backgroundColor: "#fff", borderRadius: "none", borderBottomStyle: "none", boxShadow: "none" }} className='px-4 py-2'>

                <div
                    className="text-muted"
                    style={{ overflowY: "hidden" }}
                    dangerouslySetInnerHTML={{ __html: props?.section }}
                />

            </Card>
        </>
    )
}
